export { defaultTheme } from './defaultTheme';
export { getPropertyTheme } from './propertyTheme';
export { media } from './media';
export { spaces } from './spaces';

// Legacy spacing constants for backwards compatibility
export const SPACE_4 = '16px';
